export default "__VITE_ASSET__D1nGKrOk__"